import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import { isMasterByEmail } from '@/shared/utils/role'
import { getThermometerMemberVisible } from '@/modules/settings/services/thermometerFeatureService'

type UseThermometerGateResult = {
  thermoAllowed: boolean
  noteForMaster?: string
  memberVisible: boolean | null
}

export function useThermometerGate(): UseThermometerGateResult {
  const { user, profile } = useAuth()
  const isMaster = isMasterByEmail(user?.email) || profile?.role === 'master'
  const [memberVisible, setMemberVisible] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    getThermometerMemberVisible()
      .then((on) => {
        if (mounted) setMemberVisible(!!on)
      })
      .catch(() => {
        if (mounted) setMemberVisible(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  const thermoAllowed = isMaster ? true : !!memberVisible
  const noteForMaster =
    isMaster && memberVisible === false
      ? 'Recurso habilitado somente para usuario master'
      : undefined

  return { thermoAllowed, noteForMaster, memberVisible }
}

